import React, { Component } from "react";
import { Modal, ModalBody } from "reactstrap";
import eventsHub from "../../utils/eventshub";

window.alert = message => {
  eventsHub.setShowAlert(message);
};

class ModalAlert extends Component {
  state = {
    isOpen: false,
    text: "",
  };
  onShowAlertEvent = null;

  constructor(props) {
    super(props);

    this.refButton = React.createRef();
  }

  componentDidMount() {
    this.onShowAlertEvent = eventsHub.onShowAlertEvent().subscribe(message => {
      this.setState({ isOpen: true, text: message });
      setTimeout(() => {
        this.refButton.current.focus();
      });
    });
  }

  componentWillUnmount() {
    if (this.onShowAlertEvent) {
      this.onShowAlertEvent.unsubscribe();
      this.onShowAlertEvent = null;
    }
  }

  onAlertModalToggle() {
    this.setState({ isOpen: !this.state.isOpen });
  }

  render() {
    return (
      <Modal isOpen={this.state.isOpen} toggle={this.onAlertModalToggle.bind(this)} keyboard={false} backdrop="static">
        <ModalBody className="m-3">
          <p className="">{this.state.text}</p>
          <div className="text-right">
            <button
              type="button"
              ref={this.refButton}
              className="btn btn-primary w-25 m-2"
              onClick={this.onAlertModalToggle.bind(this)}
            >
              OK
            </button>
          </div>
        </ModalBody>
      </Modal>
    );
  }
}

export default ModalAlert;
